import React from "react";
import { ChannelModel } from "../../models/ChannelModel";
import { ChannelProvider, ChannelType } from "./ChannelProvider";
import {
  ALFAMARTIPaymu,
  ALFAMARTMidtrans,
  BANKOTHERVAMidtrans,
  BCAVAIPaymu,
  BCAVAMidtrans,
  BCAVANicepay,
  BNIVAIPaymu,
  BNIVAMidtrans,
  BNIVANicepay,
  BRIVAIPaymu,
  BRIVAMidtrans,
  BRIVANicepay,
  GOPAYMidtrans,
  INDOMARETIPaymu,
  MANDIRIVAIPaymu,
  MANDIRIVAMidtrans,
  OVOMidtrans,
  MANDIRIVANicepay,
  PERTAMAVAMidtrans,
  QRISIPaymu,
  QRISMidtrans,
  SHOPEEMidtrans,
  GLOBALIfortepay,
  BAGVAIPaymu,
  BPDBaliVAIPaymu,
  BMIVAIPaymu,
  BSIVAIPaymu,
  CIMBVAIPaymu,
  PermataVAIPaymu,
  DanamonVAIPaymu
} from "./interfaces/midtrans-channel";
import { BCAVAFlip, BNIVAFlip, BRIVAFlip, BSIVAFlip, CIMBVAFlip, DanaFlip, DanamonVAFlip, DokuFlip, GopayFlip, MandiriVAFlip, OvoFlip, PermataVAFlip, QrisFlip, SeabankVAFlip, ShopeeFlip } from "./interfaces/ry-flip.channel";
import { PLINKChannel } from "./interfaces/plink.channel";

import {
  getPaymentsByProgramScope as fetchPaymentsByProgramScope,
  PaymentScopeParams,
} from "../../helpers/payment-scope.helper";
import { PaymentData, PaymentResultInterface } from "./interfaces/payment-result.interface";

export type ChannelContextType = {
  channels: ChannelModel[];
  midtransChannels: ChannelModel[];
  ipaymuChannels: ChannelModel[];
  nicepayChannels: ChannelModel[];
  walletChannels: ChannelModel[];
  ifortepayChannels: ChannelModel[];
  ryFlipChannels: ChannelModel[];
  ryFlipWalletChannels: ChannelModel[];
  plinkChannels: ChannelModel[];
  loadingChannels?: boolean;
  getPaymentChannels: (params?: PaymentScopeParams) => Promise<void>;
  getPaymentsByProgramScope: (
    params?: PaymentScopeParams
  ) => Promise<PaymentResultInterface>;
};

export const ChannelContext = React.createContext<ChannelContextType | null>(
  null
);

export const ChannelContextProvider: React.FC<React.ReactNode> = ({
  children,
}) => {
  const [walletChannels, setWalletChannels] = React.useState<ChannelModel[]>(
    []
  );
  const [channels, setChannels] = React.useState<ChannelModel[]>([]);
  const [midtransChannels, setMidtransChannels] = React.useState<
    ChannelModel[]
  >([]);
  const [ipaymuChannels, setIpaymuChannels] = React.useState<ChannelModel[]>(
    []
  );
  const [nicepayChannels, setNicepayChannels] = React.useState<ChannelModel[]>(
    []
  );
  const [ifortepayChannels, setIfortepayChannels] = React.useState<
    ChannelModel[]
  >([]);
  const [ryFlipChannels, setRyFlipChannels] = React.useState<ChannelModel[]>(
    []
  );
  const [ryFlipWalletChannels, setRyFlipWalletChannels] = React.useState<
    ChannelModel[]
  >([]);
  const [plinkChannels, setPlinkChannels] = React.useState<ChannelModel[]>([]);
  const [loadingChannels, setLoadingChannels] = React.useState<boolean>(false);

  React.useEffect(() => {
    getPaymentChannels();
  }, []);

  const getChannel = () => {
    var channelProvider: ChannelProvider = new ChannelProvider();
    let c = channelProvider.getChannels();
    setMidtransChannels(c);
  };

  const populateChannelsFromItems = (items: PaymentData[]) => {
    const manualChannels: ChannelModel[] = [];
    const walletList: ChannelModel[] = [];
    const midtransList: ChannelModel[] = [];
    const ipaymuList: ChannelModel[] = [];
    const nicepayList: ChannelModel[] = [];
    const ifortepayList: ChannelModel[] = [];
    const ryFlipList: ChannelModel[] = [];
    const ryFlipWalletList: ChannelModel[] = [];
    const plinkList: ChannelModel[] = [];

    if (items && items.length > 0) {
      for (const item of items) {
        const desc = item.description?.toLowerCase() || "";
        const name = item.name?.toLowerCase() || "";

        // Manual Bank Transfer
        if (
          desc !== "midtrans" &&
          desc !== "ipaymu" &&
          desc !== "wallet" &&
          desc !== "nicepay" &&
          desc !== "ifortepay" &&
          desc !== "ry_flip" &&
          desc !== "plink"
        ) {
          manualChannels.push({
            id: item.id,
            thumbnail: `${item.name?.toLowerCase()} sprite`,
            type: ChannelType.MANUAL_BANK_TRANSFER,
            payment_type: "manual_bank_transfer",
            code: item.name?.toLowerCase(),
            title: item.name,
            subtitle: item.description,
            hows: [
              {
                name: "Transfer Manual",
                steps: [
                  "Pilih Transfer pada menu utama bank pilihan Anda. Transfer bisa dilakukan melalui ATM, SMS Banking, atau Internet Banking.",
                  "Masukkan nomor rekening di atas. Kemudian, masukkan nominal sesuai dengan jumlah yang tertera pada nominal diatas.",
                ],
              },
            ],
            account_number: item.account_number,
            image_payment: item.image_payment,
            created_at: item.created_at,
          });
        }

        // Wallet
        if (desc === "wallet") {
          walletList.push({
            id: item.id,
            thumbnail: `wallet.png`,
            type: ChannelType.UNIVERSA_WALLET,
            payment_type: "wallet",
            code: item.name?.toLowerCase(),
            title: item.name,
            subtitle: "Pembayaran menggunakan Wallet",
            hows: [
              {
                name: "Wallet",
                steps: ["Dipotong langsung dari saldo wallet anda"],
              },
            ],
            account_number: item.account_number,
            image_payment: item.image_payment,
          });
        }

        // Midtrans Payment
        if (desc === "midtrans") {
          switch (name) {
            case "bca virtual account":
              midtransList.push({
                id: item.id,
                ...BCAVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "mandiri virtual account":
              midtransList.push({
                id: item.id,
                ...MANDIRIVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "bni virtual account":
              midtransList.push({
                id: item.id,
                ...BNIVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "bri virtual account":
              midtransList.push({
                id: item.id,
                ...BRIVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "permata virtual account":
              midtransList.push({
                id: item.id,
                ...PERTAMAVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "bank lainnya":
              midtransList.push({
                id: item.id,
                ...BANKOTHERVAMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "gopay":
              midtransList.push({
                id: item.id,
                ...GOPAYMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "ovo":
              midtransList.push({
                id: item.id,
                ...OVOMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "shopee":
              midtransList.push({
                id: item.id,
                ...SHOPEEMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "qris":
              midtransList.push({
                id: item.id,
                ...QRISMidtrans,
                image_payment: item.image_payment,
              });
              break;
            case "alfamart":
              midtransList.push({
                id: item.id,
                ...ALFAMARTMidtrans,
                image_payment: item.image_payment,
              });
              break;
          }
        }

        // IPAYMU Payment
        if (desc === "ipaymu") {
          switch (name) {
            case "bca virtual account":
              ipaymuList.push({
                id: item.id,
                ...BCAVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "mandiri virtual account":
              ipaymuList.push({
                id: item.id,
                ...MANDIRIVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "qris":
              ipaymuList.push({
                id: item.id,
                ...QRISIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "alfamart":
              ipaymuList.push({
                id: item.id,
                ...ALFAMARTIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "indomaret":
              ipaymuList.push({
                id: item.id,
                ...INDOMARETIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bni virtual account":
              ipaymuList.push({
                id: item.id,
                ...BNIVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bri virtual account":
              ipaymuList.push({
                id: item.id,
                ...BRIVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bsi virtual account":
              ipaymuList.push({
                id: item.id,
                ...BSIVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bmi virtual account":
              ipaymuList.push({
                id: item.id,
                ...BMIVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "permata virtual account":
              ipaymuList.push({
                id: item.id,
                ...PermataVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "danamon virtual account":
              ipaymuList.push({
                id: item.id,
                ...DanamonVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bag virtual account":
              ipaymuList.push({
                id: item.id,
                ...BAGVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "bpd bali virtual account":
              ipaymuList.push({
                id: item.id,
                ...BPDBaliVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
            case "cimb virtual account":
              ipaymuList.push({
                id: item.id,
                ...CIMBVAIPaymu,
                image_payment: item.image_payment,
              });
              break;
          }
        }

        // NICEPAY Payment
        if (desc === "nicepay") {
          switch (name) {
            case "bca virtual account":
              nicepayList.push({
                id: item.id,
                ...BCAVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "mandiri virtual account":
              nicepayList.push({
                id: item.id,
                ...MANDIRIVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "bni virtual account":
              nicepayList.push({
                id: item.id,
                ...BNIVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "bri virtual account":
              nicepayList.push({
                id: item.id,
                ...BRIVANicepay,
                image_payment: item.image_payment,
              });
              break;
          }
        }

        // iFortepay
        if (desc === "ifortepay") {
          switch (name) {
            case "bca virtual account":
              ifortepayList.push({
                id: item.id,
                ...BCAVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "mandiri virtual account":
              ifortepayList.push({
                id: item.id,
                ...MANDIRIVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "bni virtual account":
              ifortepayList.push({
                id: item.id,
                ...BNIVANicepay,
                image_payment: item.image_payment,
              });
              break;
            case "bri virtual account":
              ifortepayList.push({
                id: item.id,
                ...BRIVANicepay,
                image_payment: item.image_payment,
              });
              break;
            default:
              ifortepayList.push({
                id: item.id,
                ...GLOBALIfortepay,
                image_payment: item.image_payment,
              });
              break;
          }
        }

        // RY Flip
        if (desc === "ry_flip") {
          const isMobile =
            typeof window !== "undefined" && window.innerWidth <= 768;
          let flipItem: ChannelModel | null = null;
          switch (name) {
            case "bca virtual account":
              flipItem = {
                id: item.id,
                ...BCAVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "bsi virtual account":
              flipItem = {
                id: item.id,
                ...BSIVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "bni virtual account":
              flipItem = {
                id: item.id,
                ...BNIVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "mandiri virtual account":
              flipItem = {
                id: item.id,
                ...MandiriVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "bri virtual account":
              flipItem = {
                id: item.id,
                ...BRIVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "cimb virtual account":
              flipItem = {
                id: item.id,
                ...CIMBVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "danamon virtual account":
              flipItem = {
                id: item.id,
                ...DanamonVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "permata virtual account":
              flipItem = {
                id: item.id,
                ...PermataVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "seabank virtual account":
              flipItem = {
                id: item.id,
                ...SeabankVAFlip,
                image_payment: item.image_payment,
              };
              break;
            case "ovo":
              flipItem = {
                id: item.id,
                ...OvoFlip,
                image_payment: item.image_payment,
              };
              break;
            case "dana":
              flipItem = {
                id: item.id,
                ...DanaFlip,
                image_payment: item.image_payment,
              };
              break;
            case "shopeepay":
              flipItem = {
                id: item.id,
                ...ShopeeFlip,
                image_payment: item.image_payment,
              };
              break;
            case "qris":
              flipItem = {
                id: item.id,
                ...QrisFlip,
                image_payment: item.image_payment,
              };
              break;
            case "doku":
              flipItem = {
                id: item.id,
                ...DokuFlip,
                image_payment: item.image_payment,
              };
              break;
            case "gopay":
              if (isMobile) {
                flipItem = {
                  id: item.id,
                  ...GopayFlip,
                  image_payment: item.image_payment,
                };
              }
              break;
          }

          if (flipItem) {
            if (flipItem.payment_type === "wallet_account") {
              ryFlipWalletList.push(flipItem);
            } else {
              ryFlipList.push(flipItem);
            }
          }
        }

        // Plink
        if (desc === "plink") {
          plinkList.push({
            id: item.id,
            ...PLINKChannel,
            image_payment: item.image_payment,
          });
        }
      }
    }

    manualChannels.sort((a, b) => {
      const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
      const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
      return dateA - dateB;
    });

    setChannels(manualChannels);
    setWalletChannels(walletList);
    setMidtransChannels(midtransList);
    setIpaymuChannels(ipaymuList);
    setNicepayChannels(nicepayList);
    setIfortepayChannels(ifortepayList);
    setRyFlipChannels(ryFlipList);
    setRyFlipWalletChannels(ryFlipWalletList);
    setPlinkChannels(plinkList);
  };

  const getPaymentsByProgramScope = async (
    scopeParams?: PaymentScopeParams
  ): Promise<PaymentResultInterface> => {
    return fetchPaymentsByProgramScope(scopeParams);
  };

  const getPaymentChannels = async (scopeParams?: PaymentScopeParams) => {
    setLoadingChannels(true);
    try {
      const response = await fetchPaymentsByProgramScope(scopeParams);
      if (response?.status && response.data?.items) {
        populateChannelsFromItems(response.data.items);
      } else {
        populateChannelsFromItems([]);
      }
    } catch (e) {
      console.error("Failed to load payment channels:", e);
      populateChannelsFromItems([]);
    } finally {
      setLoadingChannels(false);
    }
  };

  return (
    <ChannelContext.Provider
      value={{
        channels,
        midtransChannels,
        ipaymuChannels,
        walletChannels,
        nicepayChannels,
        ifortepayChannels,
        ryFlipChannels,
        ryFlipWalletChannels,
        plinkChannels,
        loadingChannels,
        getPaymentChannels,
        getPaymentsByProgramScope,
      }}
    >
      {children}
    </ChannelContext.Provider>
  );
};
